import React, { Component } from 'react'

export default class Spacer20 extends Component {
    render() {
        return (
            <div className={this.props.className}>
                <div style={{height: 20, width: 1}}></div>
            </div>
        );
    };
}
